import { render, staticRenderFns } from "./i18n.md?vue&type=template&id=39e7de50"
import script from "./i18n.md?vue&type=script&lang=js"
export * from "./i18n.md?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports